import React from 'react';
import logo from '../static/logo.jpg';

const HeaderLogo = () => {
    return(
        <figure className="logo level image is-128x128">
            <img src={logo} alt="MI Plus" />
        </figure>
    )
}

const Header = () => {
    return(
        <div className="header">
            <div className="container">
            </div>
        </div>
    )
}

export default Header;